





























































































































import { Component, Vue, Prop } from 'vue-property-decorator'
import Partner from '@/components/public/Partner.vue'
import router from '@/router'
import buyApi from '@/api/buyApi'
import moment from 'moment'
import listApi from '@/api/listApi'
import ShowImg from '@/components/ui/ShowImg.vue'
@Component({
  components: {
    Partner,
    ShowImg
  },
  filters: {
    formatYMD(value: any) {
      return moment(Number(value)).format('YYYY年MM月DD日')
    }
  }
})
export default class ConfirmBuy extends Vue {
  private goodsId: string = ''
  private step: string = ''
  private isContinue: string = 'false'
  private orderData: any = {
    channels: [],
    notChannels: []
  }
  private note: string = ''
  private goodsList: any = []
  private resubmit: string = ''
  private firstOwnerName = ''
  private createOrderStatus: boolean = false
  public mounted() {
    this.getOrder()
    this.getResourcesListLeft()
  }

  // 进页面渲染
  private getOrder() {
    buyApi.confirmOrder({
      orderCode: this.$route.query.orderCode,
      resouceId: this.$route.query.id,
      resubmit: this.resubmit || '', // 是否重复提交 
      orderCommitEnum: this.$route.query.orderCommitEnum || 'SHOPING' , // 提交方式
      uniqueKey:sessionStorage.getItem('uniqueKey')
    }).then((res) => {
      if (res.code === 200) {
        this.orderData = res.data
        this.firstOwnerName = res.data.ownerName.split(';')[0]
        if (res.data.channels.length === 0) {
          this.$message.warning('该资源没有可购买渠道');
        }
      } else {
        this.$message.warning(res.msg);
      }
    })
  }

  // 获取广告位
  private getResourcesListLeft() {
    listApi.getHotList({
      businessType: 'PROMOTION',
      position: 'CONFIRM_ORDER',
    }).then((res) => {
      if (res.code === 200 && res.data.length > 0) {
        this.goodsList = res.data
      }
    })
  }

  // 点击支付 
  protected pay() {
    if (this.createOrderStatus) {
      return
    }
    this.createOrderStatus = true
    buyApi.submitOrder({
      orderCode: this.$route.query.orderCode,
      autoBuy: this.isContinue,
      remark: this.note,
      resourceId: this.$route.query.id,
      shopCartId: this.orderData.shopCartId,
      orderCommitEnum: this.$route.query.orderCommitEnum || 'SHOPING',
      uniqueKey:sessionStorage.getItem('uniqueKey')
    }).then((res) => {
      this.createOrderStatus = false
      if (res.code === 200) {
        this.$router.push({ name: 'pay', query: { orderNo: res.data.orderCode } })
      } else if (res.code === 262533) {
        this.resubmit = 'true'
        this.getOrder()
      } else if (res.code === 262534) {
        this.$message.warning('未获取到可购买渠道');
      } else {
        this.$message.warning(res.msg);
      }
    })
  }
}
